/* eslint-disable react/prop-types */

import { css, Rule } from 'glamor'
import * as React from 'react'

import { UiTheme, useTheme } from '../../theme'

const getStyles = (theme: UiTheme) => ({
  table: {
    base: {
      display: 'table',
      width: '100%',
      margin: 0,
      padding: 0,
      borderSpacing: 0,
    },
  },

  row: {
    base: {
      margin: 0,
      paddingLeft: 0,
      paddingRight: 0,
      '&:last-child > td': { borderBottom: 0 },
    },
  },

  cell: {
    base: {
      ...theme.typography.body,
      borderBottom: theme.settings.borders.regular,
      color: theme.colors.text.normal,
      paddingRight: theme.settings.spacing.xSmall,
      paddingLeft: theme.settings.spacing.xSmall,
      paddingTop: theme.settings.spacing.xSmall,
      paddingBottom: theme.settings.spacing.xSmall,
      textAlign: 'left',
    },

    align: {
      left: {
        textAlign: 'left',
      },

      center: {
        textAlign: 'center',
      },

      right: {
        textAlign: 'right',
      },
    },
  },
})

interface IOrderedStepsTableRowProps {
  children: React.ReactNode
  onClick?: () => void
  style?: Rule
}
export const OrderedStepsTableRow: React.FC<IOrderedStepsTableRowProps> = ({
  children,
  style,
  onClick,
  ...additional
}) => {
  const styles = getStyles(useTheme())
  return (
    <tr {...css([styles.row.base, onClick, style])} onClick={onClick} {...additional}>
      {children}
    </tr>
  )
}

interface IOrderedStepsTableCellProps {
  children?: React.ReactNode
  onClick?: () => void
  style?: Rule
  align?: 'left' | 'center' | 'right'
}

export const OrderedStepsTableCell: React.FC<IOrderedStepsTableCellProps> = ({
  children,
  style,
  align = 'left',
  ...additional
}) => {
  const styles = getStyles(useTheme())
  return (
    <td {...css(styles.cell.base, styles.cell.align[align], style)} {...additional}>
      {children}
    </td>
  )
}

interface IOrderedStepsTableProps {
  children: React.ReactNode
  style?: Rule
}

export const OrderedStepsTable: React.FC<IOrderedStepsTableProps> = ({ children, style, ...additional }) => {
  const styles = getStyles(useTheme())
  return (
    <table {...css({ ...styles.table.base, ...style })} {...additional}>
      <tbody>{children}</tbody>
    </table>
  )
}
